import { useTranslation } from "react-i18next";

export default function WebsiteBuilderOptions() {
  const { t } = useTranslation();
  const websiteBuilderOptions = [
    {
      label: t("Overview"),
      url: "/admin/website-builder",
    },
    {
      label: t("Logo & Brand"),
      url: "/admin/website-builder-logo-and-brand",
    },
    {
      label: t("Settings"),
      url: "/admin/website-builder-settings",
    },
    {
      label: t("Forms & Submissions"),
      url: "/admin/website-builder-forms",
    },
  ];

  return websiteBuilderOptions;
}
